// @mui
import { Link } from "@mui/material"
//
import { useTheme } from "@mui/material/styles"
import PropTypes from "prop-types"
import { Link as RouterLink } from "react-router"

import SvgIconStyle from "../SvgIconStyle"

// ----------------------------------------------------------------------

const Logo = ({ disabledLink = false, sx }) => {
  const theme = useTheme()

  const logo = (
    <SvgIconStyle
      src="/assets/icons/navbar/satelliet_logo_small.svg"
      sx={{
        width: 40,
        height: 40,
        cursor: "pointer",
        color: theme.palette.text.primary,
        ...sx,
      }}
    />
  )

  if (disabledLink) {
    return logo
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: "contents" }}>
      {logo}
    </Link>
  )
}

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
}

export default Logo
